import { render, staticRenderFns } from "./ProjectBuilding.vue?vue&type=template&id=0721cee4&scoped=true"
import script from "./ProjectBuilding.vue?vue&type=script&lang=js"
export * from "./ProjectBuilding.vue?vue&type=script&lang=js"
import style0 from "./ProjectBuilding.vue?vue&type=style&index=0&id=0721cee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0721cee4",
  null
  
)

export default component.exports